module.exports = __webpack_public_path__ + "static/012-c3bdc5d65f10145d22994b77d9bd7b41.jpg";